import * as React from "react";
import definitions from "../data/definitons.json";
import { Navbar } from "../components/NavBar";
import { deviceType } from "../components/Helper";
import info from "../data/info.json"
import versionInfo from "../data/mcu_version.json"
import link from "../data/links.json";
import warnings from "../data/warnings.json";
import { AdvancedView } from "./advanced/Main";
import { CommonView } from "./common/Main";
import { Legend } from "./common/Legend";

interface Key {
    [key: string]: any
}

export const Main = (): JSX.Element => {
    const meta: Key = definitions;
    const data: Key = info;
    const versionData:Key=versionInfo
    const [type, setType] = React.useState<string>(Object.keys(deviceType)[0]);
    const [toggleView, setViewToggle] = React.useState<boolean>(false);
    const ext: Key = data?.["extensions"];
    const mcu: Key = data?.[type];
    const [mcuInfo, setMcuInfo] = React.useState<string>(Object.keys(data?.[type])[0]);
    const [extInfo, setExtInfo] = React.useState(Object.keys(data?.["extensions"])[0]);

    const notesKey:String=extInfo.includes("T10")?extInfo.split("_")[0]+"_"+extInfo.split("_")[3]:extInfo.split("_")[0]
    
    const mcuVersionInfo=versionData[type]
    const [mcuVersion, setMcuVersion] = React.useState(mcuVersionInfo[mcuInfo][0]);
    // const mcuVersion:string[]=versionData[mcuInfo]
    
    React.useEffect(() => {
        setMcuInfo(Object.keys(data?.[type])[0])
    }, [type])
    

    return (
        <div className="container-md-fluid">
            <Navbar mcuMeta={versionData} mcu={mcuInfo} ext={extInfo} setMcu={setMcuInfo} extMeta={ext} setExt={setExtInfo} type={type} setType={setType} toggle={toggleView} setToggle={setViewToggle} mcuVersion={mcuVersion}  mcuVersionInfo={mcuVersionInfo} setMcuVersion={setMcuVersion} />
            <CommonView meta={meta} mcu={mcuInfo} ext={extInfo} mcuMeta={mcu} extMeta={ext} type={type} mcuVersion={mcuVersion} toggle={toggleView} notesKey={notesKey}/>
        </div>
    )
}